import { Col, Container, Row } from "react-bootstrap"
import ScrollAnimation from "react-animate-on-scroll"
import img1 from "../assets/img/screenshoot/1.png"
import img2 from "../assets/img/screenshoot/2.png"
import img3 from "../assets/img/screenshoot/3.png"
import img4 from "../assets/img/screenshoot/4.png"
import img5 from "../assets/img/screenshoot/5.png"
import playstore from "../assets/img/playstore.png"
import appstore from "../assets/img/appstore.png"

const Apps = () => {
  return(
    <Container className="mt-5 mb-5 pt-5 app-talent">
        <Row className="align-items-center">
            <Col md={3} className="mb-3">
                <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
                    <div className="header text-brand text-center-mobile">Mobile App Talent</div>
                    <p className="mt-4 text-center-mobile">Platform ini mengintegrasikan absensi digital yang praktis, pengelolaan tugas harian yang terarah, serta pelaporan dan monitoring yang komprehensif untuk meningkatkan produktivitas tim.</p>
                    <div className="d-flex flex-row gap-3 mt-4">
                        <div className="flex-fill">
                            <a href="https://play.google.com/store/apps/details?id=com.tema.task" target="_blank">
                                <img src={playstore} alt="" width={"100%"}/>
                            </a>
                        </div>
                        <div className="flex-fill">
                            <a href="https://apps.apple.com/id/app/tema-task/id6737762600" target="_blank">
                                <img src={appstore} alt="" width={"100%"}/>
                            </a>
                        </div>
                    </div>
                </ScrollAnimation>
            </Col>
            <Col md={9} className="mb-3">
                <ScrollAnimation animateIn='slideInRight' animateOnce={true}>
                    <div className="d-flex flex-row gap-3">
                        <img src={img1} alt="" className="hover-zoom" width={"20%"}/>
                        <img src={img2} alt="" className="hover-zoom" width={"20%"}/>
                        <img src={img3} alt="" className="hover-zoom" width={"20%"}/>
                        <img src={img4} alt="" className="hover-zoom" width={"20%"}/>
                        <img src={img5} alt="" className="hover-zoom" width={"20%"}/>
                    </div>
                </ScrollAnimation>
            </Col>
        </Row>
    </Container>
  )
}

export default Apps